// @ts-nocheck
import React, { useContext, useEffect, useMemo, useState } from "react";

import { Link } from "react-router-dom";
/// Scroll

import { Dropdown } from "react-bootstrap";

/// Image

import LogoutPage from './Logout';
import { ThemeContext } from "../../../context/ThemeContext";
import { useI18n } from "../../../context/I18nContext";
import { getActiveConnectEventQuietly, listEventExhibitors } from "../../../shared/api/services/EventsService";
import { ACTIVE_EVENT_SELECTION_CHANGED, readSelectedActiveEventId } from "../../../features/events/active-events";
import { listEventVisitorCompanies, listLastUserCompanies } from "../../../shared/api/services/LastUserCompanyService";
import { getDirectoryUser } from "../../../features/users/api/users-service";
import { fetchEventVisibilitySnapshot } from "../../../features/events/event-access";
import { extractUserBusinessIds, resolveEventParticipationType } from "../../../features/events/event-participation-type";
import { useBadgeCardDownload } from "../../../shared/hooks/useBadgeCardDownload";
import { openPreferredSupportChannel } from "../../../shared/support/supportLinks";
import { useStartWelcomeTour } from "../../../shared/onboarding/useWelcomeTour";

const extractList = (payload) => {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  const direct = payload?.data ?? payload?.items ?? payload?.result;
  if (Array.isArray(direct)) return direct;
  const nested = direct?.data ?? direct?.items ?? direct?.result;
  if (Array.isArray(nested)) return nested;
  return [];
};

const getStoredActiveEventId = () => {
  try {
    const stored = localStorage.getItem("activeEvent");
    const parsed = stored ? JSON.parse(stored) : null;
    return String(parsed?.activeEventId || parsed?.eventId || "").trim();
  } catch {
    return "";
  }
};

const USER_DETAILS_UPDATED_EVENT = 'user-details-updated';



const Header = ({ onNote }) => {
  const { locale, setLocale, t, locales } = useI18n();
  const { background, changeBackground } = useContext(ThemeContext);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL ?? "http://localhost:3000";
  const [userInfo, setUserInfo] = useState(null);
  const [currentEventType, setCurrentEventType] = useState(null);
  const [selectionVersion, setSelectionVersion] = useState(0);
  useEffect(() => {
    const bump = () => setSelectionVersion((v) => v + 1);
    window.addEventListener(ACTIVE_EVENT_SELECTION_CHANGED, bump);
    return () => window.removeEventListener(ACTIVE_EVENT_SELECTION_CHANGED, bump);
  }, []);
  const [avatarError, setAvatarError] = useState(false);
  const { isBadgeDownloading, handleBadgeDownload, badgeCanvas } = useBadgeCardDownload();
  const startWelcomeTour = useStartWelcomeTour();
  function ThemeChange(){    
    if(background.value === "light"){
      changeBackground({ value: "dark" });
    }else{
      changeBackground({value:"light"})
    }
  }
  useEffect(() => {
    const loadUserInfo = () => {
      try {
        const stored = localStorage.getItem("userDetails");
        if (stored) {
          const parsed = JSON.parse(stored);
          setUserInfo(parsed?.user ?? parsed ?? null);
          return;
        }
      } catch {
        // ignore parse errors
      }
      setUserInfo(null);
    };

    loadUserInfo();

    const handleUserDetailsUpdated = () => {
      loadUserInfo();
    };

    window.addEventListener('storage', handleUserDetailsUpdated);
    window.addEventListener(USER_DETAILS_UPDATED_EVENT, handleUserDetailsUpdated);

    return () => {
      window.removeEventListener('storage', handleUserDetailsUpdated);
      window.removeEventListener(USER_DETAILS_UPDATED_EVENT, handleUserDetailsUpdated);
    };
  }, []);

  const currentUserId = useMemo(() => {
    return userInfo?.id ?? userInfo?.user?.id ?? userInfo?.userId ?? "";
  }, [userInfo]);

  useEffect(() => {
    let active = true;

    const loadParticipationType = async () => {
      if (!currentUserId) {
        setCurrentEventType(null);
        return;
      }

      // Ortak secim oncelikli; yoksa eski kaynaklar.
      let activeEventId = readSelectedActiveEventId() || getStoredActiveEventId();
      if (!activeEventId) {
        const activeEvent = await getActiveConnectEventQuietly();
        activeEventId = String(
          activeEvent?.id ?? activeEvent?.eventId ?? activeEvent?.activeEventId ?? ''
        ).trim();
      }

      if (!activeEventId) {
        if (active) setCurrentEventType(null);
        return;
      }

      try {
        const snapshot = await fetchEventVisibilitySnapshot(activeEventId);
        const viewerRoles = Array.isArray(snapshot?.viewerRoles) ? snapshot.viewerRoles : [];
        if (!active) return;

        if (viewerRoles.includes('participant')) {
          setCurrentEventType('participant');
          return;
        }

        const [userResponse, exhibitorResponse, visitorResponse, buyerMissionResponse] = await Promise.all([
          getDirectoryUser(currentUserId),
          listEventExhibitors(activeEventId),
          listEventVisitorCompanies(activeEventId),
          listLastUserCompanies({ buyerMission: true, eventId: activeEventId }),
        ]);

        if (!active) return;

        const userDetail = userResponse?.data?.data ?? userResponse?.data ?? null;
        const exhibitorBusinesses = extractList(exhibitorResponse?.data);
        const visitorBusinesses = extractList(visitorResponse?.data);
        const buyerMissionBusinesses = extractList(buyerMissionResponse?.data);
        const userBusinessIds = extractUserBusinessIds(userDetail);
        const isBuyerMission = userBusinessIds.some((businessId) =>
          buyerMissionBusinesses.some((item) => String(item?.id ?? item?.businessId ?? '').trim() === String(businessId).trim()),
        );

        if (isBuyerMission) {
          setCurrentEventType('buyerMission');
          return;
        }

        if (viewerRoles.includes('visitor')) {
          setCurrentEventType('visitor');
          return;
        }

        setCurrentEventType(
          resolveEventParticipationType(
            userBusinessIds,
            exhibitorBusinesses.map((item) => item?.id ?? item?.businessId),
            visitorBusinesses.map((item) => item?.id ?? item?.businessId),
          ),
        );
      } catch {
        if (active) {
          setCurrentEventType(null);
        }
      }
    };

    void loadParticipationType();

    return () => {
      active = false;
    };
  }, [currentUserId, selectionVersion]);

  const resolvedAvatarUrl = useMemo(() => {
    if (!userInfo?.avatarUrl) return null;
    if (/^https?:\/\//i.test(userInfo.avatarUrl)) return userInfo.avatarUrl;
    const base = apiBaseUrl.replace(/\/$/, "");
    const path = userInfo.avatarUrl.replace(/^\//, "");
    return `${base}/${path}`;
  }, [apiBaseUrl, userInfo?.avatarUrl]);

  useEffect(() => { setAvatarError(false); }, [resolvedAvatarUrl]);

  const userInitials = useMemo(() => {
    const initials = [userInfo?.firstName, userInfo?.lastName]
      .filter(Boolean)
      .map((part) => part.trim()[0])
      .filter(Boolean)
      .slice(0, 2)
      .join("")
      .toUpperCase();
    return initials || userInfo?.email?.[0]?.toUpperCase() || "?";
  }, [userInfo]);

  const displayName = userInfo
    ? `${userInfo.firstName ?? ""} ${userInfo.lastName ?? ""}`.trim()
    : "James P. Sullivan";
  const participationBadge = useMemo(() => {
    if (currentEventType === "participant") {
      return {
        iconClass: "fa-solid fa-store",
        className: "bg-primary-subtle text-primary border border-primary-subtle",
        ariaLabel: t("company.list.categoryExhibitor"),
      };
    }

    if (currentEventType === "buyerMission") {
      return {
        iconClass: "fa-solid fa-globe",
        className: "bg-info-subtle text-info border border-info-subtle",
        ariaLabel: t("company.list.categoryBuyerMission"),
      };
    }

    if (currentEventType === "visitor") {
      return {
        iconClass: "fa-solid fa-person-walking",
        className: "bg-light text-secondary border border-light",
        ariaLabel: t("company.list.categoryVisitor"),
      };
    }

    return null;
  }, [currentEventType, t]);

  return (
    <div className="header">
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left">
				
              {/* <div className="input-group search-area d-xl-inline-flex d-none">
                <button className="input-group-text"><i className="flaticon-381-search-2 text-primary" /></button>
                <input type="text" className="form-control" placeholder={t('header.searchPlaceholder')} />
              </div> */}
            </div>
            <ul className="navbar-nav header-right main-notification">
              <li className="nav-item dropdown notification_dropdown">
                <Link to={"#"} className={`nav-link bell dz-theme-mode ${ background.value === "dark" ? "active" : ""}`}
                  onClick={() => ThemeChange()}
                >
                    <i id="icon-light" className="fas fa-sun" />
                    <i id="icon-dark" className="fas fa-moon" />  
                </Link>
							</li>
              {/*
			       <Dropdown
                as="li"
                className="nav-item  notification_dropdown "
              >
                <Dropdown.Toggle
                  variant=""
                  as="a"
                  className="nav-link  ai-icon i-false c-pointer"                 
                  role="button"
                  data-toggle="dropdown"
                >
                  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M12.638 4.9936V2.3C12.638 1.5824 13.2484 1 14.0006 1C14.7513 1 15.3631 1.5824 15.3631 2.3V4.9936C17.3879 5.2718 19.2805 6.1688 20.7438 7.565C22.5329 9.2719 23.5384 11.5872 23.5384 14V18.8932L24.6408 20.9966C25.1681 22.0041 25.1122 23.2001 24.4909 24.1582C23.8709 25.1163 22.774 25.7 21.5941 25.7H15.3631C15.3631 26.4176 14.7513 27 14.0006 27C13.2484 27 12.638 26.4176 12.638 25.7H6.40705C5.22571 25.7 4.12888 25.1163 3.50892 24.1582C2.88759 23.2001 2.83172 22.0041 3.36039 20.9966L4.46268 18.8932V14C4.46268 11.5872 5.46691 9.2719 7.25594 7.565C8.72068 6.1688 10.6119 5.2718 12.638 4.9936ZM14.0006 7.5C12.1924 7.5 10.4607 8.1851 9.18259 9.4045C7.90452 10.6226 7.18779 12.2762 7.18779 14V19.2C7.18779 19.4015 7.13739 19.6004 7.04337 19.7811C7.04337 19.7811 6.43703 20.9381 5.79662 22.1588C5.69171 22.3603 5.70261 22.6008 5.82661 22.7919C5.9506 22.983 6.16996 23.1 6.40705 23.1H21.5941C21.8298 23.1 22.0492 22.983 22.1732 22.7919C22.2972 22.6008 22.3081 22.3603 22.2031 22.1588C21.5627 20.9381 20.9564 19.7811 20.9564 19.7811C20.8624 19.6004 20.8133 19.4015 20.8133 19.2V14C20.8133 12.2762 20.0953 10.6226 18.8172 9.4045C17.5391 8.1851 15.8073 7.5 14.0006 7.5Z" fill="#759791"/>
                  </svg>
                  <span className="badge light text-white bg-secondary rounded-circle">12</span>
                </Dropdown.Toggle>
                <Dropdown.Menu align="end" className="mt-2 dropdown-menu dropdown-menu-end">
                  <div className="widget-media dz-scroll p-3 height380">
                    <ul className="timeline">
                      <li>
                        <div className="timeline-panel">
                          <div className="media me-2">
                            <img alt="images" width={50} src={avatar} />
                          </div>
                          <div className="media-body">
                            <h6 className="mb-1">Dr sultads Send you Photo</h6>
                            <small className="d-block">
                              29 July 2020 - 02:26 PM
                            </small>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="timeline-panel">
                          <div className="media me-2 media-info">KG</div>
                          <div className="media-body">
                            <h6 className="mb-1">
                              Resport created successfully
                            </h6>
                            <small className="d-block">
                              29 July 2020 - 02:26 PM
                            </small>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="timeline-panel">
                          <div className="media me-2 media-success">
                            <i className="fa fa-home" />
                          </div>
                          <div className="media-body">
                            <h6 className="mb-1">Reminder : Treatment Time!</h6>
                            <small className="d-block">
                              29 July 2020 - 02:26 PM
                            </small>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="timeline-panel">
                          <div className="media me-2">
                            <img alt="" width={50} src={avatar} />
                          </div>
                          <div className="media-body">
                            <h6 className="mb-1">Dr sultads Send you Photo</h6>
                            <small className="d-block">
                              29 July 2020 - 02:26 PM
                            </small>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="timeline-panel">
                          <div className="media me-2 media-danger">KG</div>
                          <div className="media-body">
                            <h6 className="mb-1">
                              Resport created successfully
                            </h6>
                            <small className="d-block">
                              29 July 2020 - 02:26 PM
                            </small>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="timeline-panel">
                          <div className="media me-2 media-primary">
                            <i className="fa fa-home" />
                          </div>
                          <div className="media-body">
                            <h6 className="mb-1">Reminder : Treatment Time!</h6>
                            <small className="d-block">
                              29 July 2020 - 02:26 PM
                            </small>
                          </div>
                        </div>
                      </li>
                    </ul>                    
                  </div>
                  <Link className="all-notification" to="#">
                    {t('header.seeAllNotifications')} <i className="ti-arrow-right" />
                  </Link>
                </Dropdown.Menu>
              </Dropdown>
			        <Dropdown
                as="li"
                className="nav-item dropdown notification_dropdown "
              >
                <Dropdown.Toggle
                  variant=""
                  as="a"
                  className="nav-link bell bell-link i-false c-pointer ai-icon"
                  onClick={() => onNote()}
                >
                  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M27 7.88883C27 5.18897 24.6717 3 21.8 3C17.4723 3 10.5277 3 6.2 3C3.3283 3 1 5.18897 1 7.88883V23.7776C1 24.2726 1.31721 24.7174 1.80211 24.9069C2.28831 25.0963 2.8473 24.9912 3.2191 24.6417C3.2191 24.6417 5.74629 22.2657 7.27769 20.8272C7.76519 20.3688 8.42561 20.1109 9.11591 20.1109H21.8C24.6717 20.1109 27 17.922 27 15.2221V7.88883ZM24.4 7.88883C24.4 6.53951 23.2365 5.44441 21.8 5.44441C17.4723 5.44441 10.5277 5.44441 6.2 5.44441C4.7648 5.44441 3.6 6.53951 3.6 7.88883V20.8272L5.4382 19.0989C6.4132 18.1823 7.73661 17.6665 9.11591 17.6665H21.8C23.2365 17.6665 24.4 16.5726 24.4 15.2221V7.88883ZM7.5 15.2221H17.9C18.6176 15.2221 19.2 14.6745 19.2 13.9999C19.2 13.3252 18.6176 12.7777 17.9 12.7777H7.5C6.7824 12.7777 6.2 13.3252 6.2 13.9999C6.2 14.6745 6.7824 15.2221 7.5 15.2221ZM7.5 10.3333H20.5C21.2176 10.3333 21.8 9.7857 21.8 9.11104C21.8 8.43638 21.2176 7.88883 20.5 7.88883H7.5C6.7824 7.88883 6.2 8.43638 6.2 9.11104C6.2 9.7857 6.7824 10.3333 7.5 10.3333Z" fill="#759791"/>
                  </svg>
                  <span className="badge light text-white bg-secondary rounded-circle">5</span>
                </Dropdown.Toggle>
              </Dropdown>
			  
			  
			        <Dropdown as="li" className="nav-item dropdown notification_dropdown ">
                <Dropdown.Toggle
                  className="nav-link i-false c-pointer ai-icon" variant="" as="a"
                  data-toggle="dropdown" aria-expanded="false"
                        >
                  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.88552 6.2921C1.95571 6.54135 0.439911 8.19656 0.439911 10.1896V10.7253C0.439911 12.8874 2.21812 14.6725 4.38019 14.6725H12.7058V24.9768H7.01104C5.77451 24.9768 4.82009 24.0223 4.82009 22.7858V18.4039C4.84523 16.6262 2.16581 16.6262 2.19096 18.4039V22.7858C2.19096 25.4334 4.36345 27.6059 7.01104 27.6059H21.0331C23.6807 27.6059 25.8532 25.4334 25.8532 22.7858V13.9981C26.9064 13.286 27.6042 12.0802 27.6042 10.7253V10.1896C27.6042 8.17115 26.0501 6.50077 24.085 6.28526C24.0053 0.424609 17.6008 -1.28785 13.9827 2.48534C10.3936 -1.60185 3.7545 1.06979 3.88552 6.2921ZM12.7058 5.68103C12.7058 5.86287 12.7033 6.0541 12.7058 6.24246H6.50609C6.55988 2.31413 11.988 1.90765 12.7058 5.68103ZM21.4559 6.24246H15.3383C15.3405 6.05824 15.3538 5.87664 15.3383 5.69473C15.9325 2.04532 21.3535 2.18829 21.4559 6.24246ZM4.38019 8.87502H12.7058V12.0382H4.38019C3.62918 12.0382 3.06562 11.4764 3.06562 10.7253V10.1896C3.06562 9.43859 3.6292 8.87502 4.38019 8.87502ZM15.3383 8.87502H23.6656C24.4166 8.87502 24.9785 9.43859 24.9785 10.1896V10.7253C24.9785 11.4764 24.4167 12.0382 23.6656 12.0382H15.3383V8.87502ZM15.3383 14.6725H23.224V22.7858C23.224 24.0223 22.2696 24.9768 21.0331 24.9768H15.3383V14.6725Z" fill="#759791"/> 
                  </svg>
                  <span className="badge light text-white bg-secondary rounded-circle">2</span>
                </Dropdown.Toggle>	
                <Dropdown.Menu align="end" className="mt-4 dropdown-menu dropdown-menu-end">
                  <div className="widget-timeline dz-scroll style-1 ps p-3 height370">
                    <ul className="timeline">
                      <li>
                        <div className="timeline-badge primary" />
                        <Link
                          className="timeline-panel c-pointer text-muted"
                          to="#"
                        >
                          <span>10 minutes ago</span>
                          <h6 className="mb-0">
                            Youtube, a video-sharing website, goes live{" "}
                            <strong className="text-primary">$500</strong>.
                          </h6>
                        </Link>
                      </li>
                      <li>
                        <div className="timeline-badge info"></div>
                        <Link
                          className="timeline-panel c-pointer text-muted"
                          to="#"
                        >
                          <span>20 minutes ago</span>
                          <h6 className="mb-0">
                            New order placed{" "}
                            <strong className="text-info">#XF-2356.</strong>
                          </h6>
                          <p className="mb-0">
                            Quisque a consequat ante Sit amet magna at
                            volutapt...
                          </p>
                        </Link>
                      </li>
                      <li>
                        <div className="timeline-badge danger"></div>
                        <Link
                          className="timeline-panel c-pointer text-muted"
                          to="#"
                        >
                          <span>30 minutes ago</span>
                          <h6 className="mb-0">
                            john just buy your product{" "}
                            <strong className="text-warning">Sell $250</strong>
                          </h6>
                        </Link>
                      </li>
                      <li>
                        <div className="timeline-badge success"></div>
                        <Link
                          className="timeline-panel c-pointer text-muted"
                          to="#"
                        >
                          <span>15 minutes ago</span>
                          <h6 className="mb-0">
                            StumbleUpon is acquired by eBay.{" "}
                          </h6>
                        </Link>
                      </li>
                      <li>
                        <div className="timeline-badge warning"></div>
                        <Link
                          className="timeline-panel c-pointer text-muted"
                          to="#"
                        >
                          <span>20 minutes ago</span>
                          <h6 className="mb-0">
                            Mashable, a news website and blog, goes live.
                          </h6>
                        </Link>
                      </li>
                      <li>
                        <div className="timeline-badge dark"></div>
                        <Link
                          className="timeline-panel c-pointer text-muted"
                          to="#"
                        >
                          <span>20 minutes ago</span>
                          <h6 className="mb-0">
                            Mashable, a news website and blog, goes live.
                          </h6>
                        </Link>
                      </li>
                    </ul>
                    <div className="ps__rail-x" style={{ left: 0, bottom: 0 }}>
                      <div
                        className="ps__thumb-x"
                        tabIndex={0}
                        style={{ left: 0, width: 0 }}
                      />
                    </div>
                    <div className="ps__rail-y" style={{ top: 0, right: 0 }}>
                      <div
                        className="ps__thumb-y"
                        tabIndex={0}
                        style={{ top: 0, height: 0 }}
                      />
                    </div>
                  </div>
                </Dropdown.Menu>
	              </Dropdown>
              */}
	              <Dropdown as="li" className="nav-item  notification_dropdown ">
                <Dropdown.Toggle  as="div"  className="form-control language-btn i-false ">
                  {t(locale === 'tr' ? 'language.turkish' : 'language.english')}
                  <i className="fa fa-caret-down ms-2"></i>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {locales.map((lang) => (
                    <Dropdown.Item key={lang.key} onClick={() => setLocale(lang.key)}>
                      {t(lang.labelKey)}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
				
              <Dropdown as="li" className="nav-item dropdown header-profile" data-tour="profile-menu">
                <Dropdown.Toggle variant="" as="a" className="nav-link i-false c-pointer"
                  role="button" data-toggle="dropdown"
                        >
                  <div className="header-info me-3 d-flex align-items-center gap-2">
                    {participationBadge ? (
                      <span
                        className={`d-inline-flex align-items-center justify-content-center rounded-pill px-2 py-1 ${participationBadge.className}`}
                        style={{ lineHeight: 1, minWidth: 34 }}
                        title={participationBadge.ariaLabel}
                        aria-label={participationBadge.ariaLabel}
                      >
                        <i className={participationBadge.iconClass} />
                      </span>
                    ) : null}
                    <span className="fs-16 font-w600 ">{displayName || "James P. Sullivan"}</span>
                  </div>
                  {resolvedAvatarUrl && !avatarError ? (
                    <img
                      src={resolvedAvatarUrl}
                      width={44}
                      height={44}
                      className="rounded-circle"
                      alt=""
                      style={{
                        objectFit: 'contain',
                        objectPosition: 'center',
                        padding: 6,
                        boxSizing: 'border-box',
                        backgroundColor: '#fff',
                      }}
                      onError={() => setAvatarError(true)}
                    />
                  ) : (
                    <span
                      style={{
                        display: 'flex',
                        width: 44,
                        height: 44,
                        borderRadius: '50%',
                        background: '#3b82f6',
                        color: '#fff',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 15,
                        fontWeight: 600,
                        flexShrink: 0,
                      }}
                    >
                      {userInitials}
                    </span>
                )}
              </Dropdown.Toggle>
                <Dropdown.Menu
                  align="end"
                  className="mt-0 dropdown-menu-end"
                  style={{ minWidth: 240, width: "max-content", maxWidth: "calc(100vw - 24px)" }}
                >
                  <button
                    type="button"
                    className="dropdown-item ai-icon border-0 bg-transparent w-100 text-start"
                    onClick={handleBadgeDownload}
                    disabled={isBadgeDownloading}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="text-primary"
                      width={18}
                      height={18}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M12 17V3" />
                      <path d="m6 11 6 6 6-6" />
                      <path d="M19 21H5" />
                    </svg>
                    <span className="ms-2">
                      {isBadgeDownloading ? t("header.badgeCard.downloading") : t("header.badgeCard.action")}
                    </span>
                  </button>
                  <Link to="/app-profile" className="dropdown-item ai-icon">
                    <svg
                      id="icon-user1" xmlns="http://www.w3.org/2000/svg" className="text-primary"
                      width={18} height={18} viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"
                    >
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                      <circle cx={12} cy={7} r={4} />
                    </svg>
                    <span className="ms-2">{t("header.profile")}</span>
                  </Link>
                  <Link to="/settings" className="dropdown-item ai-icon">
                    <i className="fa-solid fa-gear text-primary" style={{ width: 18, fontSize: 18 }} />
                    <span className="ms-2">{t("menu.settings")}</span>
                  </Link>
                  <Dropdown.Item
                    as="button"
                    type="button"
                    className="dropdown-item ai-icon border-0 bg-transparent w-100 text-start"
                    onClick={startWelcomeTour}
                  >
                    <i className="fa-solid fa-route text-primary" style={{ width: 18, fontSize: 18 }} />
                    <span className="ms-2 text-wrap">{t("tour.start")}</span>
                  </Dropdown.Item>
                  <button
                    type="button"
                    className="dropdown-item ai-icon border-0 bg-transparent w-100 text-start"
                    onClick={openPreferredSupportChannel}
                  >
                    <i className="bi bi-headset text-primary" style={{ width: 18, fontSize: 18 }} />
                    <span className="ms-2">Destek</span>
                  </button>
                  {/*
                  <Link to="/email-inbox" className="dropdown-item ai-icon">
                    <svg id="icon-inbox" xmlns="http://www.w3.org/2000/svg" className="text-success"
                      width={18} height={18} viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"
                    >
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                      <polyline points="22,6 12,13 2,6" />
                    </svg>
                    <span className="ms-2">Inbox </span>
                  </Link>
                  */}
                  <LogoutPage />
                </Dropdown.Menu>
              </Dropdown>
            </ul>
          </div>
        </nav>
        {badgeCanvas}
      </div>
    </div>
  );
};

export default Header;
